import { GetUser } from '../graphql/GetUser.gql'
//import { ApolloClient } from 'apollo-client';
//import gql from 'graphql-tag';
import { apolloClient } from '../mixin/apollo.js'



export default async function auth({ next, to, router, store }) {


  
  // clien enter to welcome page
    if (to.name == "welcome") {
        if (localStorage.getItem('apollo-token')) {
          
            try {
                let user = await apolloClient.query({
                    query: GetUser
                })
                store.state.userData = {username: user.data.currentUser.username, name: user.data.currentUser.name}
                return router.push({ name: 'app' })
            }
            catch (error) {
                return next();
            }
        }
    }
  
  // clien enter to secured page
    if (to.meta.authRequired) {
      if (!localStorage.getItem('apollo-token')) {
        return router.push({ name: 'welcome' })
      }else{
        try {
          let user = await apolloClient.query({
              query: GetUser,
          })
          store.state.userData = {username: user.data.currentUser.username, name: user.data.currentUser.name}
          return next();
      }
      catch {
        return router.push({ name: 'welcome' })
        }
      }
  }

    return next();

}



/*

// Manually call this when user log in
export async function onLogin (apolloClient, token) {
    localStorage.setItem(AUTH_TOKEN, JSON.stringify(token))
    if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
    try {
      await apolloClient.resetStore()
    } catch (e) {
      if (!isUnauthorizedError(e)) {
        console.log('%cError on cache reset (login)', 'color: orange;', e.message)
      }
    }
  }

  // Manually call this when user log out
  export async function onLogout (apolloClient) {
    localStorage.removeItem(AUTH_TOKEN)
    if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
    try {
      await apolloClient.resetStore()
    } catch (e) {
      if (!isUnauthorizedError(e)) {
        console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
      }
    }
  }

  */